/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import './styles.less';
import { Popup } from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { CustomDatePicker } from '../../../../../semantic-ui/components/custom-datepicker';
import { FormCheckboxField } from '../../../../../semantic-ui/components/form-checkbox-field';
import { CargoExpressDeliveryBadge } from '../../cargo-express-delivery-badge';
import { CustomLoader } from '../../../../../components/custom-loader';
import { ErrorComponent } from '../../../../../components/error-component';

export const CargoExpressDeliveryFormView = ({ reqInfo, isLoading }) => {
	if (isLoading) {
		return <CustomLoader />;
	}

	return (
		<div className="cargo-express-delivery-form">
			<header className="cargo-express-delivery-form__header">
				<span className="cargo-express-delivery-form__header-text cargo-express-delivery-form__header-text_min-weight ">
					<span className="cargo-express-delivery-form__header-text cargo-express-delivery-form__header-text_bold">{`Заявка № ${reqInfo.id}`}</span>
					{` от ${reqInfo.created_at}`}
				</span>
				<span className="cargo-express-delivery-form__header-text">
					{`${reqInfo?.company?.name} `}
					<span className="cargo-express-delivery-form__header-text cargo-express-delivery-form__header-text_small">
						{reqInfo?.company?.address}
					</span>
				</span>
			</header>

			<section className="cargo-express-delivery-form__date-section">
				<div className="cargo-express-delivery-form__date-field">
					<Field
						name="done_at"
						type="text"
						component={CustomDatePicker}
						autoComplete="off"
						placeholder=" . . / . . / . . . ."
						dateFormat={['dd.MM.yyyy', 'dd-MM-yyyy', 'dd/MM/yyyy']}
						isWithoutErrorText
					/>
				</div>
				<span className="cargo-express-delivery-form__date-text">Уĸажите дату доставки груза</span>
			</section>
			<section className="cargo-express-delivery-form__date-section">
				<Field name="done_at" component={ErrorComponent} />
			</section>
			<ul className="cargo-express-delivery-form__route-list">
				{reqInfo.points?.map(el => {
					return (
						<li key={el.id} className="cargo-express-delivery-form__route-item">
							<header className="cargo-express-delivery-form__route-header">
								<Popup
									content="Выберите выполненные точки доставки"
									trigger={
										<div className="cargo-express-delivery-form__checkbox-wrapper">
											<Field
												name={`points.${el.id}`}
												type="checkbox"
												component={FormCheckboxField}
											/>
										</div>
									}
									position="right center"
									size="mini"
									inverted
									style={{
										textAlign: 'center',
										fontSize: 12,
										fontWeight: '500',
										marginLeft: '12px',
									}}
								/>
								<span className="cargo-express-delivery-form__route-title cargo-express-delivery-form__route-title_small">
									{`#${el.id}, ${el.company}, ${el.address}`}
								</span>
							</header>
							<div className="cargo-express-delivery-form__route-info-field">
								<div className="cargo-express-delivery-form__route-info-item">
									<CargoExpressDeliveryBadge text={el.weight} isSmall />
									<span className="cargo-express-delivery-form__route-info-text">кг</span>
								</div>
								<div className="cargo-express-delivery-form__route-info-item">
									<CargoExpressDeliveryBadge text={el.volume} isSmall />
									<span className="cargo-express-delivery-form__route-info-text">м³</span>
								</div>
							</div>
						</li>
					);
				})}
			</ul>
		</div>
	);
};

CargoExpressDeliveryFormView.propTypes = {
	reqInfo: PropTypes.object,
	isLoading: PropTypes.bool,
};
